import React from 'react';
import PropTypes from 'prop-types';

import './AnnotationControlsField.css';
import { ICON_PATH } from '../../../constants';


const AnnotationControlsField = ({ onDelete, onEdit }) => (
  <div className="annotation-controls">
    <img src={`${ICON_PATH}/edit-icon.svg`} className="icon" alt="Edit" onClick={onEdit} role="presentation" />
    <img src={`${ICON_PATH}/delete-icon.svg`} className="icon" alt="Delete" onClick={onDelete} role="presentation" />
  </div>
);


AnnotationControlsField.propTypes = {
  onDelete: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};


export default AnnotationControlsField;
